<template>
    <input ref="inputElement" :name="name" type="checkbox" data-switch="true" />
</template>

<script setup lang="ts">
    import { Switch } from "@/portal/formControls/Switch";
    import { onMounted, ref, watch } from "vue";

    const model = defineModel<boolean>({ required: true });
    const props = defineProps<{
        name?: string;
        disabled?: boolean;
    }>();

    const inputElement = ref<HTMLInputElement>();

    let component: Switch | undefined = undefined;
    onMounted(() => {
        component = new Switch($(inputElement.value!));
        component.onChange = (value) => {
            model.value = value;
        };
        component.setValue(model.value);
        component.setDisabled(props.disabled ?? false);
    });

    watch(model, (value) => {
        component?.setValue(value);
    });

    watch(
        () => props.disabled,
        (value) => {
            component?.setDisabled(value ?? false);
        }
    );
</script>
